// API base URL — habilita chamadas cross-origin no deploy workers.dev/pages.dev.
//
// Dev/test: VITE_API_BASE_URL ausente → '' → paths relativos (/api/...). Em dev
//   o Vite faz proxy (/api → :8787). Em teste o fetch é mockado com path relativo.
// Produção pages.dev: VITE_API_BASE_URL = https://api.contatofacilites.workers.dev
//   → fetch absoluto. Front (comite-contato-facilites.pages.dev) e API em origens
//   distintas; o CORS do Worker permite a origem do front.

const API_BASE = import.meta.env.VITE_API_BASE_URL ?? '';

/** Prefixa `path` com a base da API (vazio em dev/test → path relativo). */
export function apiUrl(path: string): string {
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE}${path}`;
}
